import React, { useEffect } from "react";

import { colors } from "@zapalacorp/tokens";
import { useTranslation } from "react-i18next";

import Breadcrumb from "../../../../../../components/Generic/Breadcrump";
import { UploadCentreProvider } from "../../../../../../context/UploadCentreContext";
import { Upload } from "./components/Upload";
import { Header, Section, Wrapper } from "./styles";

type Props = {
  permission?: {
    edit: boolean;
  };
};

const UploadCentre = (props: Props) => {
  const { permission } = props;
  const { t: translate } = useTranslation();

  return (
    <Wrapper>
      {/* <Header>
        <Breadcrumb
          items={[
            { title: translate("configurations") },
            {
              title: translate("uploadCentre"),
              color: colors.gray800,
              dataCy: "breadcrumbsSubTitle",
            },
          ]}
        />
      </Header> */}
      <UploadCentreProvider>
        <Section>
          <Upload permission={permission} />
        </Section>
      </UploadCentreProvider>
    </Wrapper>
  );
};

export default UploadCentre;
